import { Box, Button, CircularProgress, LinearProgress, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";
import { Envelope } from "../types";
import { StatsState } from "../useStats";

/** Loading and error for one endpoint, once, so the cards inside only draw data. */
export default function StatsGate<T>({ state, children }: {
  state: StatsState<T>;
  children: (data: T, envelope: Envelope<T>) => ReactNode;
}) {
  if (state.error) {
    return (
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Typography color="text.secondary" sx={{ mb: state.error.kind === "forbidden" ? 0 : 1 }}>
          {state.error.message}
        </Typography>
        {state.error.kind !== "forbidden" && <Button size="small" onClick={state.retry}>Retry</Button>}
      </Paper>
    );
  }
  if (!state.envelope) {
    return <Box sx={{ py: 6, textAlign: "center" }}><CircularProgress /></Box>;
  }
  return (
    <Box>
      {state.loading && <LinearProgress sx={{ mb: 1 }} />}
      {children(state.envelope.data, state.envelope)}
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
        Updated {new Date(state.envelope.generatedAt).toLocaleTimeString()}
      </Typography>
    </Box>
  );
}
